import { ErrorHandler, Injectable } from "@angular/core";
import { LogService, LogLevel } from "../data-services/log.service";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable({
   providedIn: 'root'
})
export class ErrorLogger implements ErrorHandler {

   constructor() {
   }

   handleError(error) {
      var msg: string;

      if (error instanceof HttpErrorResponse) {
        msg = `UI: There was an HTTP error. ${error.message} Status code: ${(<HttpErrorResponse>error).status}`;
      } else if (error instanceof TypeError) {
         msg = `UI: There was a Type error. ${error.message} Stack: ${(<TypeError>error).stack}`;
      } else if (error instanceof Error) {
         msg = `UI: There was a general error. ${error.message} Stack: ${(<Error>error).stack}`;
      } else {
         msg = `UI: Nobody threw an Error but something happened! ${error}`;
      }

      console.log(msg, error.stack);

      //this.logService.sendToLog(LogLevel.Error, msg).subscribe(() => {
      //   console.log(msg);
      //});
   }
}
